import { useEffect } from "react";

export default function usePageMeta({ title, description }) {
  useEffect(() => {
    const previous = document.title;
    if (title) document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    const previousDesc = meta?.getAttribute("content");
    if (description && meta) meta.setAttribute("content", description);

    return () => {
      document.title = previous;
      if (previousDesc && meta) meta.setAttribute("content", previousDesc);
    };
  }, [title, description]);
}
